import { useState } from "react";
import React from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  Typography,
  Switch,
  SelectChangeEvent,
  ListItemText,
  Checkbox,
  OutlinedInput,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const vendors =[
  "Vendor A",
  "Vendor B",
  "Vendor c",
]

const names = [
  "Electronics",
  "Apparel",
  "Beverages",
 
];

const EditDiscount = () => {
  const [personName, setPersonName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [type, setType] = React.useState("default");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };
  const [isRecommended, setIsRecommended] = useState(true);

  return (
    <>
      <div className="main_title">
        <h1>Edit Discount and Coupon</h1>
      </div>
      <div className="cards custom_form_details">
        <div className="form">
          <div className="gap_m w_100">
            <div className="control_group w_50">
              <label htmlFor="text">Offer/Discount Name</label>
              <TextField
                id="text"
                placeholder="Enter Discount Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="text">Minimum Sales (Orders)</label>
              <TextField
                id="text"
                placeholder="eg . 10 orders"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="email">Discount Type</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Discount Type
                </MenuItem>
                <MenuItem value="broadcast">percentage</MenuItem>
                <MenuItem value="email">Flaat</MenuItem>
                <MenuItem value="email">Both (XX% off up to ₹YY)</MenuItem>
              </Select>
            </div>

            <div className="control_group w_25">
              <label htmlFor="text">Discount (%)</label>
              <TextField
                id="text"
                placeholder="Enter Discount (%)"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_25">
              <label htmlFor="text">Flat Amount</label>
              <TextField
                id="text"
                placeholder="Enter Flat Amount"
                fullWidth
                hiddenLabel
              />
            </div>
           

            <div className="control_group w_50">
              <label htmlFor="email">Applicable Time Slot</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Time Slot
                </MenuItem>
                <MenuItem value="broadcast">Morning (8 AM - 12 PM)</MenuItem>
                <MenuItem value="email">Afternoon (12 PM - 4 PM)</MenuItem>
                <MenuItem value="email">Afternoon (12 PM - 4 PM)</MenuItem>
              </Select>
            </div>

             <div className="control_group w_50">
              <label htmlFor="email">Valid From - To</label>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="Pick date" />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      id: "dob",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>
            <div className="control_group w_50">
              <label htmlFor="email">Applicable Products / Categories</label>
              <Select
                labelId="Applicable Products or Categories"
                id="demo-multiple-checkbox"
                multiple
                displayEmpty
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <span style={{ color: "#aaa" }}>
                        Select Products or Categories
                      </span>
                    );
                  }
                  return selected.join(", ");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value="">
                  <em>Select Products or Categories</em>
                </MenuItem>
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </div>

             <div className="control_group w_50">
              <label htmlFor="email">Applicable Merchants / Vendors</label>
              <Select
                labelId="Applicable Products or Categories"
                id="demo-multiple-checkbox"
                multiple
                displayEmpty
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <span style={{ color: "#aaa" }}>
                        Select Vendors
                      </span>
                    );
                  }
                  return selected.join(", ");
                }}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value="">
                  <em>Select Products or Categories</em>
                </MenuItem>
                {vendors.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </div>
                <div className="control_group w_50">
              <label htmlFor="text">Coupon Code</label>
              <TextField
                disabled
                id="text"
                placeholder="Will be auto-generated"
                fullWidth
                hiddenLabel
              />
            </div>
            
          </div>
        </div>
      </div>

      <Box textAlign="center" mt={3}>
        <Button
          className="btn_primary"
          variant="contained"
          sx={{ borderRadius: "8px", px: 6, py: 1.5 }}
        >
          Save
        </Button>
      </Box>
    </>
  );
};

export default EditDiscount;
